// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { useHotelPartnerId } from './useHotelPartnerId';
import { supabase } from '@/integrations/supabase/client';

export interface HotelAssignedEvent {
  event_id: string;
  event_name: string;
  start_date: string | null;
  end_date: string | null;
  venue_city: string | null;
  venue_state: string | null;
}

/**
 * Events assigned to the signed-in hotel partner account.
 * hotel_event_assignments.hotel_partner_user_id is the resolved partner account id.
 */
export function useHotelAssignedEvents() {
  const { data: partnerId } = useHotelPartnerId();

  return useQuery({
    queryKey: ['hotel-assigned-events', partnerId],
    queryFn: async () => {
      const { data: assignments, error: aErr } = await (supabase as any)
        .from('hotel_event_assignments')
        .select('event_id')
        .eq('hotel_partner_user_id', partnerId);
      if (aErr) throw aErr;
      if (!assignments || assignments.length === 0) return [];

      const eventIds = assignments.map((a) => a.event_id);

      const { data: events, error: eErr } = await supabase
        .from('events')
        .select('id, name, start_date, end_date, venue_city, venue_state')
        .in('id', eventIds)
        .order('start_date', { ascending: true });
      if (eErr) throw eErr;

      return (events ?? []).map((ev): HotelAssignedEvent => ({
        event_id: ev.id,
        event_name: ev.name,
        start_date: ev.start_date,
        end_date: ev.end_date,
        venue_city: ev.venue_city,
        venue_state: ev.venue_state,
      }));
    },
    enabled: !!partnerId,
  });
}
